import { Calendar, CheckCircle, Briefcase, Settings, XCircle, ArchiveRestore } from 'lucide-react';
import type { AgroProductStats } from '@/modules/agro/pages/types/agro.types';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';

interface AgroProductKpiGridProps {
  stats: AgroProductStats;
  isLoading?: boolean;
}

export function AgroProductKpiGrid({ stats, isLoading }: AgroProductKpiGridProps) {
  const outOfStockCount = stats.outOfStockCount || 0;
  const expiredCount = stats.expiredCount || 0;
  const incomingCount = 0; // Dummy
  const disposedCount = 0; // Dummy
  const total = stats.totalAssets || 0;

  const kpis: KpiItem[] = [
    {
      title: 'Tổng vật tư',
      value: total,
      suffix: 'Loại',
      icon: Calendar,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'neutral',
      trendValue: 'Tổng quan',
      chartColor: 'bg-blue-500',
      chartData: [50, 50, 50, 50, 50, 50, 50]
    },
    {
      title: 'Sẵn sàng',
      value: stats.availableCount,
      suffix: total ? `${Math.round((stats.availableCount / total) * 100)}%` : '0%',
      icon: CheckCircle,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Trong kho',
      chartColor: 'bg-emerald-500',
      chartData: [60, 65, 70, 75, 80, 85, 90]
    },
    {
      title: 'Đang về',
      value: incomingCount,
      suffix: 'Chờ nhập',
      icon: Briefcase,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'neutral',
      trendValue: 'Đặt hàng',
      chartColor: 'bg-indigo-500',
      chartData: [20, 25, 20, 15, 20, 20, 20]
    },
    {
      title: 'Hết hàng',
      value: outOfStockCount,
      suffix: total ? `${Math.round((outOfStockCount / total) * 100)}%` : '0%',
      icon: Settings,
      color: 'text-orange-600',
      bg: 'bg-orange-50',
      trend: 'down',
      trendValue: 'Cần nhập',
      chartColor: 'bg-orange-500',
      chartData: [5, 10, 5, 5, 10, 5, 5]
    },
    {
      title: 'Hết hạn',
      value: expiredCount,
      suffix: total ? `${Math.round((expiredCount / total) * 100)}%` : '0%',
      icon: XCircle,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'down',
      trendValue: 'Phế phẩm',
      chartColor: 'bg-rose-500',
      chartData: [0, 0, 5, 0, 0, 0, 0]
    },
    {
      title: 'Đã hủy',
      value: disposedCount,
      suffix: total ? `${Math.round((disposedCount / total) * 100)}%` : '0%',
      icon: ArchiveRestore,
      color: 'text-slate-600',
      bg: 'bg-slate-100',
      trend: 'neutral',
      trendValue: 'Tiêu hủy',
      chartColor: 'bg-slate-500',
      chartData: [2, 2, 2, 2, 2, 2, 2]
    },
  ];

  return <KpiGrid kpis={kpis} isLoading={isLoading} />;
}
